/**
 * ActiveGauge — Donut-style placeholder for partner active %.
 * Renders CSS ring; values stay empty until Dashboard API exists.
 */
export default function ActiveGauge({ percent = null, label = "ACTIVE" }) {
  const display =
    percent === null || percent === undefined ? "—" : `${percent}%`;
  const ringPct =
    percent === null || percent === undefined
      ? 0
      : Math.min(100, Math.max(0, Number(percent)));

  return (
    <div className="dash-gauge-wrap">
      <div
        className="dash-gauge-ring"
        style={{
          background: `conic-gradient(#10B981 ${ringPct * 3.6}deg, #F3F4F6 0deg)`,
        }}
      >
        <div className="dash-gauge-center">
          <div className="dash-gauge-pct">{display}</div>
          <div className="dash-gauge-label">{label}</div>
        </div>
      </div>
    </div>
  );
}
